module.exports = __webpack_public_path__ + "img/iphone-feature-bg-03.1f175628.svg";